import { render, staticRenderFns } from "./Inform.vue?vue&type=template&id=6798b5ae&scoped=true&"
import script from "./Inform.vue?vue&type=script&lang=js&"
export * from "./Inform.vue?vue&type=script&lang=js&"
import style0 from "./Inform.vue?vue&type=style&index=0&id=6798b5ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798b5ae",
  null
  
)

export default component.exports